import { render, staticRenderFns } from "./supervise.vue?vue&type=template&id=f197f1da&scoped=true"
import script from "./supervise.vue?vue&type=script&lang=js"
export * from "./supervise.vue?vue&type=script&lang=js"
import style0 from "./supervise.vue?vue&type=style&index=0&id=f197f1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f197f1da",
  null
  
)

export default component.exports